module.exports = __webpack_public_path__ + "static/media/schedule.f52db7b4.svg";